module.exports = __webpack_public_path__ + "img/sign_in.f004e825.svg";